import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '@/routes'
import store from '@/store'
import {isEmbeddableRoute} from '@@/helpers'
import {hasEmbeddedQuery} from '@@/helpers'

Vue.use(VueRouter)

/**
 * Check in the metadata if the current
 * route needs auth and handle it.
 * ----------------------------------------
 * @function
 */
function getStoreToken () {
  return _.get(store.state.user, 'token')
}

function hasPermissionTo (to) {
  var currentBS = localStorage.getItem('GEODIS')
  if(to.name == "Profile" || to.name == "home" || to.name == "test") return true
  let path = to.path.split('/');
  let index = path.lastIndexOf(currentBS)
  let action = path[index + 1].replace(/%20/g, " ");
  let entity = window.$Schema.find(f => f.name == action)
  return entity
    ?  entity.actions && entity.actions.index
    : true
}

function needsUnsetPortal(to) {
  return (
    to.name
    && !to.name.endsWith('.portal')
    && !to.name.includes('.add')
    && !to.name.includes('.edit')
  );
}

function unsetPortal(next) {
  store.commit('SET_PORTAL_TEMPLATE', '');
  next();
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes
})

/**
 * Check in the metadata if the current
 * route needs auth and handle it.
 * ----------------------------------------
 * @function
 */
router.beforeEach((to, from, next) => {
  const guest = to.matched.some(r => r.meta.guest);
  const isAuth = getStoreToken();
  const fromIsEmbedded = isEmbeddableRoute(from)
  const toIsEmbedded = isEmbeddableRoute(to)
  if (isAuth && hasEmbeddedQuery(to)) next()
  else if (isAuth && isEmbeddableRoute(to)) next()
  else if (isAuth && fromIsEmbedded && !toIsEmbedded) next({ name: `embeddable.${to.name}` })
  else if (!isAuth && to.name == 'auth') next()
  else if (!isAuth && !guest) next('/auth/login')
  else if (isAuth && guest) next('/')
  else if (isAuth && !hasPermissionTo(to)) next('/')
  else if (needsUnsetPortal(to)) unsetPortal(next)
  else if(hasEmbeddedQuery(to) && !isAuth && !guest) next('/auth/login?embedded=True&screen=Shipment')
  else next()
})

export default router
